// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-tree {
  width: 100%;
  height: 90%;
  overflow-y: auto;
  overflow-x: hidden;
}
.file-tree::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.file-tree-loading {
  display: flex;
  justify-content: center;
  align-items: center;
}
.file-tree-loading img {
  width: 0.25rem;
  height: 0.25rem;
}
.file-tree .ant-tree {
  width: 100%;
  background: none;
  font-family: Roboto;
}
.file-tree .ant-tree-title {
  width: 100%;
  font-size: 0.0875rem;
  height: 0.25rem;
  margin-left: 0.05rem;
}
.file-tree .ant-tree-treenode {
  margin-bottom: 0;
  line-height: 0.125rem;
}
.file-tree .ant-tree .anticon {
  font-size: 0.075rem;
  margin-top: 0.03125rem;
  color: #8b8589;
}
.file-tree .ant-tree .anticon-file {
  font-size: 0.075rem;
}
.file-tree .ant-tree .anticon-folder {
  font-size: 0.0875rem;
}
.file-tree .ant-tree .anticon-plus-square,
.file-tree .ant-tree .anticon-minus-square {
  font-size: 0.1rem;
}
.file-tree .ant-tree .ant-dropdown-trigger {
  font-size: 0.0875rem;
}
.file-tree .ant-tree .ant-dropdown-menu-item {
  font-size: 0.0875rem;
  padding: 0.0125rem 0.0625rem;
}
.file-tree .ant-tree .ant-dropdown-menu-item .anticon {
  font-size: 0.075rem;
}
.file-tree .ant-tree .ant-tree-node-content-wrapper {
  min-height: auto;
}
.file-tree .ant-tree .ant-tree-node-content-wrapper .handle-btns {
  display: none;
}
.file-tree .ant-tree .ant-tree-node-content-wrapper:hover {
  border-radius: 0.0375rem;
}
.file-tree .ant-tree .ant-tree-node-content-wrapper:hover .handle-btns {
  display: inline-block;
}
.file-tree .ant-tree .ant-tree-node-content-wrapper .anticon {
  margin-left: 0.05rem;
}
.file-tree .ant-tree .ant-tree-node-content-wrapper.ant-tree-node-selected {
  background: rgba(214, 206, 194, 0.7);
  border-radius: 0.0375rem;
}
.file-tree .ant-tree .ant-tree-switcher {
  display: none;
}
.file-tree .ant-tree .ant-tree-treenode {
  min-width: 0.1875rem;
  max-width: 5rem;
  white-space: nowrap;
}
.file-tree .ant-tree .ant-tree-treenode-switcher-open,
.file-tree .ant-tree .ant-tree-treenode-switcher-close {
  margin-left: 0;
}
.file-tree .ant-tree .ant-input-outlined:focus {
  border: none;
  box-shadow: none;
  height: 0.2125rem;
  border-radius: 0.05rem;
  font-size: 0.0875rem;
}
.file-tree .ant-tree .ant-tree-iconEle {
  width: auto;
  height: auto;
}
.file-tree .ant-tree-indent-unit {
  width: 0.03125rem;
}
.file-tree .ant-tree-indent-unit::before {
  display: none;
}
.file-tree .ant-tree-switcher-leaf-line {
  display: none;
}
.file-tree .ant-tree-node-indent {
  margin-left: 0.125rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/component/fileTree/index.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AACF;AAAE;EACE,QAAA;EACA,SAAA;AAEJ;AAAE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAEJ;AADI;EACE,cAAA;EACA,eAAA;AAGN;AAAE;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;AAEJ;AADI;EACE,WAAA;EACA,oBAAA;EACA,eAAA;EACA,oBAAA;AAGN;AADI;EACE,gBAAA;EACA,qBAAA;AAGN;AADI;EACE,mBAAA;EACA,sBAAA;EACA,cAAA;AAGN;AADI;EACE,mBAAA;AAGN;AADI;EACE,oBAAA;AAGN;AADI;;EAEE,iBAAA;AAGN;AADI;EACE,oBAAA;AAGN;AADI;EACE,oBAAA;EACA,4BAAA;AAGN;AAFM;EACE,mBAAA;AAIR;AADI;EACE,gBAAA;AAGN;AAFM;EACE,aAAA;AAIR;AAFM;EACE,wBAAA;AAIR;AAHQ;EACE,qBAAA;AAKV;AAFM;EACE,oBAAA;AAIR;AAFM;EACE,oCAAA;EACA,wBAAA;AAIR;AADI;EACE,aAAA;AAGN;AADI;EACE,oBAAA;EACA,eAAA;EACA,mBAAA;AAGN;AADI;;EAEE,cAAA;AAGN;AADI;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,oBAAA;AAGN;AADI;EACE,WAAA;EACA,YAAA;AAGN;AAAE;EAIE,iBAAA;AADJ;AAFI;EACE,aAAA;AAIN;AAAE;EACE,aAAA;AAEJ;AAAE;EACE,qBAAA;AAEJ","sourcesContent":[".file-tree {\n  width: 100%;\n  height: 90%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  &::-webkit-scrollbar {\n    width: 0;\n    height: 0;\n  }\n  &-loading {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    img {\n      width: 40px;\n      height: 40px;\n    }\n  }\n  .ant-tree {\n    width: 100%;\n    background: none;\n    font-family: Roboto;\n    &-title {\n      width: 100%;\n      font-size: 14px;\n      height: 40px;\n      margin-left: 8px;\n    }\n    &-treenode {\n      margin-bottom: 0;\n      line-height: 20px;\n    }\n    .anticon {\n      font-size: 12px;\n      margin-top: 5px;\n      color: #8b8589;\n    }\n    .anticon-file {\n      font-size: 12px;\n    }\n    .anticon-folder {\n      font-size: 14px;\n    }\n    .anticon-plus-square,\n    .anticon-minus-square {\n      font-size: 16px;\n    }\n    .ant-dropdown-trigger {\n      font-size: 14px;\n    }\n    .ant-dropdown-menu-item {\n      font-size: 14px;\n      padding: 2px 10px;\n      .anticon {\n        font-size: 12px;\n      }\n    }\n    .ant-tree-node-content-wrapper {\n      min-height: auto;\n      .handle-btns {\n        display: none;\n      }\n      &:hover {\n        border-radius: 6px;\n        .handle-btns {\n          display: inline-block;\n        }\n      }\n      .anticon {\n        margin-left: 8px;\n      }\n      &.ant-tree-node-selected {\n        background: rgba(214, 206, 194, 0.7);\n        border-radius: 6px;\n      }\n    }\n    .ant-tree-switcher {\n      display: none;\n    }\n    .ant-tree-treenode {\n      min-width: 30px;\n      max-width: 800px;\n      white-space: nowrap;\n    }\n    .ant-tree-treenode-switcher-open,\n    .ant-tree-treenode-switcher-close {\n      margin-left: 0;\n    }\n    .ant-input-outlined:focus {\n      border: none;\n      box-shadow: none;\n      height: 34px;\n      border-radius: 8px;\n      font-size: 14px;\n    }\n    .ant-tree-iconEle {\n      width: auto;\n      height: auto;\n    }\n  }\n  .ant-tree-indent-unit {\n    &::before {\n      display: none;\n    }\n    width: 5px;\n  }\n  .ant-tree-switcher-leaf-line {\n    display: none;\n  }\n  .ant-tree-node-indent {\n    margin-left: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
